



import { Component, Vue, Prop, Watch} from 'vue-property-decorator';
import * as Components from '@/tenant/components';
import * as Common from '@/tenant/common';

@Component
export default class AtcSegment extends Vue {
  @Prop({ default: '' }) public title: string;
  @Prop({ default: null }) public value?: any | Common.IMasterItem;
  @Prop({ default: false }) public required: boolean;
  @Prop({ default: null }) public editor: Components.IEditor;
  @Prop({ default: true }) public enabled: boolean;
  @Prop({ default: true }) public setInitialValue: boolean;
  @Prop() public tooltip: string;
  public isEdit: boolean = true;
  public validator: Components.ControlValidator = null;
  public query: string = '';

  public created() {
    //親Editorに登録する
    if (this.editor != null) this.editor.addControl(this);
    //this.query = this.value;
    this.query = 'SegmentMasterQuery';
  }
  destroyed(){
    if (this.editor != null) this.editor.removeControl(this);    
  }  
  public get internalValue(): string {
    return this.value;
  }

  public set internalValue(value: string) {
    // 親コンポーネント側で更新
    this.$emit('update:value', value);
    this.$emit('changed');
  }
    public onLinkClicked(){
      if (this.value){
        // this.$router.push(String.format('/master/Segment?auditNo={0}', (this.value as Common.Segment).code));   
        let routeData = this.$router.resolve(String.format('/master/Segment?auditNo={0}', (this.value as Common.Segment).code));
        window.open(routeData.href, '_blank');                
      }          
    }     
   @Watch('isEdit')
    isEditChanged(newEdit:boolean, oldEdit:boolean) {
      if(newEdit==true && this.value==null && this.setInitialValue==true){
        this.$api.execute(new Common.SegmentMasterQuery()).then(result => {
        if((result as Common.LoadResult).records==1){
          this.$emit('update:value', (result as Common.LoadResult).result[0]);
        }
      });
      }
    }
}
  
